import React, { useState } from 'react';
import TopBar from './components/TopBar';
import Sidebar from './components/Sidebar';
import ContentArea from './components/ContentArea';

// Mock data for gyms
const mockGyms = [
  { id: 'gym-1', name: 'Downtown BJJ Academy', logoUrl: '' },
  { id: 'gym-2', name: 'Elite MMA Center', logoUrl: '' },
  { id: 'gym-3', name: 'Warrior Fitness', logoUrl: '' },
];

// Tab configurations for each section
const sectionTabs: Record<string, Array<{ id: string; label: string }>> = {
  dashboard: [
    { id: 'overview', label: 'Overview' },
    { id: 'insights', label: 'Insights' },
    { id: 'goals', label: 'Goals' },
  ],
  schedule: [
    { id: 'calendar', label: 'Calendar' },
    { id: 'classes', label: 'Classes' },
    { id: 'instructors', label: 'Instructors' },
  ],
  students: [
    { id: 'directory', label: 'Directory' },
    { id: 'attendance', label: 'Attendance' },
    { id: 'upload', label: 'Upload Data' },
  ],
  pulse: [
    { id: 'analytics', label: 'Analytics' },
    { id: 'reports', label: 'Reports' },
    { id: 'trends', label: 'Trends' },
  ],
  billing: [
    { id: 'plans', label: 'Plans' },
    { id: 'invoices', label: 'Invoices' },
    { id: 'payments', label: 'Payment Methods' },
  ],
};

// Page titles for each section
const sectionTitles: Record<string, string> = {
  dashboard: 'Dashboard',
  schedule: 'Schedule',
  students: 'Students',
  pulse: 'RollOps Pulse',
  billing: 'Billing & Subscriptions',
};

/**
 * Prototype Navigation System
 * Implementing the Holy Grail layout with Top Bar, Sidebar, and Content Area
 * Sidebar is collapsed by default and expands on hover
 */
export default function Prototype() {
  // State management
  const [currentGym, setCurrentGym] = useState(mockGyms[0]);
  const [activeSection, setActiveSection] = useState('dashboard');
  const [activeTabs, setActiveTabs] = useState<Record<string, string>>({
    dashboard: 'overview',
    schedule: 'calendar',
    students: 'directory',
    pulse: 'analytics',
    billing: 'plans',
  });

  // Handlers
  const handleGymSwitch = (gymId: string) => {
    const gym = mockGyms.find(g => g.id === gymId);
    if (gym) {
      setCurrentGym(gym);
    }
  };

  const handleCreateGym = () => {
    alert('Create New Gym functionality would open here');
  };

  const handleSectionChange = (section: string) => {
    setActiveSection(section);
  };

  const handleTabChange = (tabId: string) => {
    setActiveTabs(prev => ({
      ...prev,
      [activeSection]: tabId,
    }));
  };

  const currentTabs = sectionTabs[activeSection] || [];
  const currentActiveTab = activeTabs[activeSection] || currentTabs[0]?.id;
  const currentTitle = sectionTitles[activeSection] || 'Page';

  return (
    <div className="min-h-screen bg-[#111010]">
      {/* Top Bar - Fixed Header */}
      <TopBar
        currentGym={currentGym}
        gyms={mockGyms}
        onGymSwitch={handleGymSwitch}
        onCreateGym={handleCreateGym}
      />

      {/* Main Layout Container */}
      <div className="flex pt-16">
        {/* Sidebar - Fixed Left Navigation (expands on hover) */}
        <Sidebar
          activeSection={activeSection}
          onSectionChange={handleSectionChange}
        />

        {/* Content Area - Main Content with Tabs */}
        {/* No left margin on mobile (sidebar hidden), ml-20 on md+ for collapsed sidebar */}
        <div className="flex-1 transition-all duration-300 ml-0 md:ml-20 pb-16 md:pb-0">
          <ContentArea
            title={currentTitle}
            tabs={currentTabs}
            activeTab={currentActiveTab}
            onTabChange={handleTabChange}
          />
        </div>
      </div>
    </div>
  );
}
